import API from "@/api";
import moment from "@/utils/moment";

export default {
  data() {
    return {
      serverTime: null
    };
  },

  methods: {
    async getServerTime() {
      try {
        const response = await API.Server.serverTime();

        this.serverTime = response.data.current_time;
      } catch (_) {
        this.serverTime = moment().unix();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/serverTimeMixin.js